interface IconProps {
  className?: string;
}

const ItalicIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M4.079 16h6.562a.41.41 0 0 0 0-.82H9.256a.42.42 0 0 1-.332-.155.37.37 0 0 1-.066-.328l2.716-10.945a1.23 1.23 0 0 1 1.194-.932h1.154a.41.41 0 0 0 0-.82H7.36a.41.41 0 0 0 0 .82h1.385a.408.408 0 0 1 .398.51L6.427 14.275c-.135.541-.615.905-1.194.905H4.08a.41.41 0 1 0 0 .82"
      ></path>
    </svg>
  );
};

export default ItalicIcon;
